// extracted by mini-css-extract-plugin
export default {"container":"poster-editor-fancy-text-fonts-panel-module__container--gNcmo"};